// Browser shim for node-fetch — redirects to native browser fetch APIs
export default globalThis.fetch.bind(globalThis)
export const Headers = globalThis.Headers
export const Request = globalThis.Request
export const Response = globalThis.Response
